// extracted by mini-css-extract-plugin
module.exports = {"publications":"styles_publications__2nn6Y"};